import { ActivityStatusEnum, ActivityTypeEnum } from '@/apis/promotions';
import WrappedModal from '@/components/ui/WrappedModal';
import useBindEmailOrLogin from '@/hooks/useBindEmailOrLogin';
import { GLOBAL_MODALS, globalModals } from '@/state/globalSettings';
import { Button, Typography } from '@mui/material';
import { Stack, Box, styled } from '@mui/system';
import { PersistRatioImage } from '@repo/ui';
import { useAtom } from 'jotai';
import { Trans, useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import SaturdayTAndC from './saturday-t-and-c';
import ThursdayTAndC from './thursday-t-and-c';
import useTheme from '@/theme/useTheme';

const BadgeContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  backgroundColor: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#FFD939',
  color: '#362E0C',
  fontsize: '24px',
  fontWeight: 700,
}));

export const TitlesComp = ({ title, subTitle, desc }) => {
  return (
    <Stack
      sx={{
        height: {
          sx: '130px',
          md: 'fit-content',
        },
        p: 2,
        background: {
          // xs: 'linear-gradient(0deg, #181A20 0%, rgba(99, 100, 104, 0.68) 60.33%, rgba(255, 255, 255, 0.00) 100%)',
          md: 'transparent',
        },
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: '40px',
          fontWeight: 400,
        }}
      >
        {title}
      </Box>

      <Box
        component="div"
        sx={{
          width: 'fit-content',
          lineHeight: 1,
          fontSize: '50px',
          fontWeight: 700,
          background:
            'linear-gradient(91deg, #FFCC0F 24.03%, #FFF 46.32%, #FFCC0F 75.27%)',
          backgroundClip: 'text',
          textFillColor: 'transparent',
        }}
      >
        {subTitle}
      </Box>

      <Typography
        sx={{
          mt: 1.25,
          display: { xs: 'none', md: 'block' },
        }}
        variant="body2"
        fontSize={'16px'}
        fontWeight={500}
        lineHeight={'20px'}
        color="text.primary"
      >
        {desc}
      </Typography>
    </Stack>
  );
};

export const ContentComp = ({ contents }) => {
  const [t] = useTranslation();

  return (
    <Stack sx={{ p: 2 }} flexDirection={{ sx: 'column', md: 'row' }}>
      {contents.map((item, index) => {
        return (
          <Stack
            key={index}
            sx={{
              mt: 2,
              p: 2,
              mr: { xs: 0, md: 2 },
              width: { xs: '100%', md: '180px' },
              // height: { sx: '90px', md: '165px'},
              fontSize: '14px',
              lineHeight: '20px',
              position: 'relative',
              borderRadius: '8px',
              border: '1px solid rgba(27, 28, 29, 0.09)',
              background: 'rgba(27, 28, 29, 0.70)',
              backdropFilter: 'blur(8.4px)',
            }}
          >
            {/* <Box sx={{height: '87px', flex: 'none', mb:1}}>
                  <PersistRatioImage
                    sx={{flex: 1}}
                    src={item.img}
                    logicWidth={169}
                    logicHeight={87}
                    alt={t('Moonclub Promotion')}
                ></PersistRatioImage>
                </Box> */}

            <Box sx={{ flex: 1 }} fontWeight={500}>
              {t(item.text)}
            </Box>

            <BadgeContainer>{index + 1}</BadgeContainer>
          </Stack>
        );
      })}
    </Stack>
  );
};

export const ButtonsComp = ({ type }: { type: ActivityTypeEnum }) => {
  const [t] = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { requirementToBindEmailOrLogin, isLogin } = useBindEmailOrLogin();
  const [, setModals] = useAtom(globalModals);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: {
            xs: 'center',
            md: 'flex-start',
          },
          p: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            if (requirementToBindEmailOrLogin()) return;
            setModals({
              [GLOBAL_MODALS.WALLET]: true,
              excludingOthers: true,
            });
          }}
          sx={{
            fontSize: '16px',
            borderRadius: '8px',
            height: '40px',
          }}
        >
          {t('Get Bonus')}
        </Button>
        <Button
          variant="outlined"
          sx={{
            fontSize: '16px',
            borderRadius: '8px',
            height: '40px',
            ml: 3,
          }}
          onClick={() => setShowModal(true)}
        >
          {t('Terms & Conidtions')}
        </Button>
      </Box>

      {type === ActivityTypeEnum.SATURDAY ? (
        <SaturdayTAndC showModal={showModal} setShowModal={setShowModal} />
      ) : (
        <ThursdayTAndC showModal={showModal} setShowModal={setShowModal} />
      )}
    </>
  );
};

export const ThursdayOrSaturdayTAndC = ({
  type,
}: {
  type: ActivityTypeEnum.THURSDAY | ActivityTypeEnum.SATURDAY;
}) => {
  const [tAndCModalOpen, setTAndCModalOpen] = React.useState(false);

  const [t] = useTranslation();

  const { theme } = useTheme();

  return (
    <>
      <Typography
        display={'inline'}
        onClick={() => setTAndCModalOpen(true)}
        component={'a'}
        sx={{
          color: theme.palette.primary.main,
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {t('rewards::Terms & Conditions')}
      </Typography>
      {type === ActivityTypeEnum.SATURDAY ? (
        <SaturdayTAndC
          showModal={tAndCModalOpen}
          setShowModal={setTAndCModalOpen}
        />
      ) : (
        <ThursdayTAndC
          showModal={tAndCModalOpen}
          setShowModal={setTAndCModalOpen}
        />
      )}
    </>
  );
};
